import { isDrawerPaneVisible } from 'owa-drawer';
import type { OwaHeaderButtonControls } from 'owa-header-types';
import { useEffect, useRef } from 'react';
import closeHeaderPane from '../orchestration/closeHeaderPane';

// When a header button loses visibility (because of availability, not layout)
// and its pane is open, close the pane.
export default function useCloseHiddenHeaderPanes(
    buttons: OwaHeaderButtonControls,
    visibleButtons: OwaHeaderButtonControls
): void {
    const previousRef = useRef<Set<string>>(undefined);

    useEffect(() => {
        const currentVisibility = new Set(visibleButtons.map(button => button.id));
        const previousVisibility = previousRef.current;

        if (previousVisibility) {
            for (const button of buttons) {
                if (
                    previousVisibility.has(button.id) &&
                    !currentVisibility.has(button.id) &&
                    button.pane &&
                    isDrawerPaneVisible(button.pane.id)
                ) {
                    closeHeaderPane(button.pane.id);
                }
            }
        }

        previousRef.current = currentVisibility;
    }, [buttons, visibleButtons]);
}
